export default __webpack_public_path__ + "static/media/Ashoka_Particle_Flame_7.6e3410a2.png";